<template>
  <div>
    <PayoutStatesModal :payout-id="activePayoutId" />
    <b-row class="mb-2">
      <b-col
        md="12"
        class="d-flex justify-content-between mb-1"
      >
        <b-button
          :disabled="validatingPayout"
          variant="warning"
          @click="validatePayout"
        >
          Validate payout
        </b-button>
      </b-col>
      <b-col md="12">
        <span
          v-if="canCreatePayout != undefined"
        >Can create payout: <strong
          :class="{
            'text-success': canCreatePayout,
            'text-danger': !canCreatePayout
          }"
        >{{ canCreatePayout ? 'Yes': 'No' }}</strong></span>
      </b-col>
    </b-row>

    <b-card>
      <!-- <b-row class="mb-1">
        <b-col md="4">
          <label for="states">Search by state</label>
          <v-select
            id="states"
            v-model="queryParams.state"
            placeholder="No state selected"
            label="label"
            :options="stateOptions"
            :reduce="(option) => option.key"
            :clearable="false"
            @input="stateChangedHandler"
          />
        </b-col>
      </b-row> -->
      <BaseOverlay :show="loading">
        <b-table
          :fields="tableColumns"
          :items="payouts"
          striped
          hover
          responsive
          show-empty
          empty-text="No matching payouts found"
        >
          <template #cell(actions)="data">
            <b-button
              size="sm"
              variant="primary"
              @click="openPayoutModal(data.item.id)"
            >
              View States
            </b-button>
          </template>
        </b-table>
        <base-pagination
          v-model="queryParams.page"
          :total="total"
          @new-per-page="queryParams.perPage = $event"
        />
      </BaseOverlay>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BTable, BRow, BCol, BButton,
} from 'bootstrap-vue'
import {
  reactive, ref, toRef, watch,
} from '@vue/composition-api'
// import vSelect from 'vue-select'
import axiosIns from '@/libs/axios'
import BasePagination from '@/UI/BasePagination.vue'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'
import formatDate from '@/utils/date-format'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import { errorNotification } from '@/utils/toast-notifications'
import PayoutStatesModal from './PayoutStatesModal.vue'

const stateOptions = [
  {
    label: 'All',
    key: 'ALL',
  },
  {
    label: 'Pending',
    key: 'pending',
  },
  {
    label: 'Declined',
    key: 'declined',
  },
  {
    label: 'Approved',
    key: 'approved',
  },
  {
    label: 'Paid',
    key: 'paid',
  },
]
export default {
  components: {
    BCard,
    BTable,
    BaseOverlay,
    BasePagination,
    BRow,
    BButton,
    BCol,
    // vSelect,
    PayoutStatesModal,
  },
  props: {
    wallet: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, ctx) {
    // const driverExternalId = ctx.root.$route.query.externalId
    const queryParams = reactive({
      page: 1,
      perPage: 10,
      // state: 'ALL',
    })
    const total = ref(0)
    const tableColumns = [
      {
        label: 'added by',
        key: 'added_by',
      },
      {
        label: 'amount',
        key: 'amount',
      },
      {
        label: 'state',
        key: 'state',
        formatter: val => snakeCaseToCamelCase(val),
      },
      {
        label: 'created at',
        key: 'created_at',
        formatter: val => formatDate(val),
      },
      'actions',
    ]
    const payouts = ref([])
    const loading = ref(false)
    const fetchPayouts = async () => {
      loading.value = true
      const res = await axiosIns.get('/payouts/db', {
        params: {
          ...queryParams,
          wallet_id: props.wallet.id,
          // state: queryParams.state === 'ALL' ? undefined : queryParams.state,
          // external_id: driverExternalId,
        },
      })
      const { items: list, total: totalPayouts } = res.data.data
      payouts.value = list
      total.value = totalPayouts
      loading.value = false
    }

    watch([toRef(queryParams, 'page'), toRef(queryParams, 'perPage')], () => {
      fetchPayouts()
    })

    const resetFilters = () => {
      fetchPayouts()
    }

    // const stateChangedHandler = () => {
    //   queryParams.page = 1
    //   fetchPayouts()
    // }

    fetchPayouts()

    const validatingPayout = ref(false)
    const canCreatePayout = ref(undefined)
    const validatePayout = async () => {
      validatingPayout.value = true
      try {
        const result = await axiosIns.get(`/validate-payout/${props.wallet.id}`)
        canCreatePayout.value = result.data.data
      } catch (err) {
        errorNotification('An erro occured')
      } finally {
        validatingPayout.value = false
      }
    }
    const activePayoutId = ref()
    const openPayoutModal = payoutId => {
      activePayoutId.value = payoutId
      ctx.root.$bvModal.show('payout-states')
    }

    return {
      payouts,
      queryParams,
      total,
      tableColumns,
      loading,
      openPayoutModal,
      activePayoutId,
      resetFilters,
      fetchPayouts,
      stateOptions,
      canCreatePayout,
      // stateChangedHandler,
      validatingPayout,
      validatePayout,
    }
  },
}
</script>
